<ion-list mode="ios" lines="none" class="list-content">
  <!-- ? Titulo y cerrar -->
  <ion-item mode="md" lines="none" color="white" class="ion-text-center">
    <ion-label
      mode="md"
      color="status-icon-enable"
      class="have-purchase-progress mpe-font-weight-600"
    >
      {{ 'Titles.have-purchase-progress' | translate }}
    </ion-label>
  </ion-item>

  <!-- * Icono -->
  <ion-item mode="md" lines="none" color="white">
    <ion-img
      [src]="'Icons.cart-progress' | translate"
      class="cart-progress"
    ></ion-img>
  </ion-item>

  <ion-item mode="md" lines="none" color="white" class="ion-text-center">
    <ion-label mode="md" color="grayDemon" class="what-want-do">
      {{ 'Labels.what-want-do' | translate }}
    </ion-label>
  </ion-item>

  <!-- ? Botones de cerrar -->
  <ion-item mode="md" lines="none" color="white">
    <ion-button
      class="mpe-button-expand-default button-stay"
      size="default"
      mode="md"
      color="tpcta"
      (click)="onClose(false)"
    >
      <ion-label mode="md" class="mpe-font-weight-600 keep-buying">
        {{ 'Buttons.keep-buying' | translate }}
      </ion-label>
    </ion-button>
  </ion-item>

  <ion-item mode="md" lines="none" color="white" class="item-footer">
    <ion-button
      class="mpe-button-link-line button-leave"
      size="default"
      mode="md"
      color="darkblue"
      fill="clear"
      (click)="onClose(true)"
    >
      <ion-label mode="md" color="darkblue" class="mpe-font-weight-600">
        {{ 'Buttons.leave-store' | translate }}
      </ion-label>
    </ion-button>
  </ion-item>

  <ion-item
    mode="md"
    lines="none"
    color="white"
    class="ion-text-center item-footer"
  >
    <ion-label mode="md" color="cadet-grey" class="save-products-cart">
      {{ 'Labels.save-products-cart' | translate }}
    </ion-label>
  </ion-item>
</ion-list>
